@use "../../styles/breakpoint.module.scss" as *;

.root {
    grid-column: content;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-12);
}

.eyebrow {
    color: var(--dark-gray);
    font: var(--font-st-20);
    font-weight: 800;
    text-align: center;
}

.track {
    position: relative;
    width: 100%;
    overflow: hidden;

    // Gradient fade on both edges
    &::before,
    &::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        width: var(--spacer-200);
        z-index: 1;
        pointer-events: none;
    }

    &::before {
        left: 0;
        background: linear-gradient(90deg, var(--white), transparent);
    }

    &::after {
        right: 0;
        background: linear-gradient(270deg, var(--white), transparent);
    }
}

.scroll {
    display: flex;
    gap: var(--spacer-80);
    width: max-content;
    will-change: transform;
    backface-visibility: hidden;
    animation: marquee 30s linear infinite;

    @media ($below-mobile) {
        gap: var(--spacer-64);
        animation-duration: 16s;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
}

.logoItem {
    flex-shrink: 0;
    height: var(--spacer-80);
    display: flex;
    align-items: center;

    img {
        max-height: var(--spacer-80);
        width: auto;
        display: block;
    }
}

@keyframes marquee {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-50%);
    }
}
